import script from "./PlanPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanPage.vue?vue&type=script&setup=true&lang=ts"

import "./PlanPage.vue?vue&type=style&index=0&id=64c56ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c56ff2"]])

export default __exports__